<template>

  <div id="quotation-other-info" class="sixteen wide column">
    <div class="ui segment">
      <h4 class="ui dividing header">Outras informações</h4>
      <form class="ui form">
        <div class="fields">
          <div class="three wide field">
            <label class="form-label">Emite laudo <span class="red text">*</span></label>
            <select id="select-issue-report" class="ui fluid dropdown" v-model="issueReport" @change="onChange()">
              <option value="">Selecione...</option>
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </div>
          <div class="three wide field">
            <label class="form-label">Aceita pallets <span class="red text">*</span></label>
            <select id="select-pallets" class="ui fluid dropdown" v-model="pallets" @change="onChange()">
              <option value="">Selecione...</option>
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </div>
          <div class="three wide field">
            <label class="form-label">Aceita fat. parcial <span class="red text">*</span></label>
            <select id="select-partial-billing" class="ui fluid dropdown">
              <option value="">Selecione...</option>
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </div>
          <div class="three wide field">
            <label class="form-label">Pedido do cliente</label>
            <input type="text" v-model="customerSalesOrder" @blur="onChange()">
          </div>
        </div>
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Observações Transportadora</label>
            <input type="text" v-model="shippingMessage" @blur="onChange()">
          </div>
          <div class="eight wide field">
            <label class="form-label">Mensagem Nota Fiscal</label>
            <input type="text" v-model="invoiceMessage" @blur="onChange()">
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script>

  import cleanSpecialChars from "@/utils/clean-special-chars"
  import QuotationService from "@/services/quotation-service"
  import { Message } from "@/utils"

  export default {

    data() {
      return {
        issueReport: "",
        pallets: "",
        partialBilling: "",
        customerSalesOrder: "",
        shippingMessage: "",
        invoiceMessage: "",
        isResetting: false,
      }
    },

    props: ["quotation", "isCreating", "isUpdating"],

    created() {

      if (this.isUpdating) {
        this.issueReport = this.quotation.isIssueReport ? "S" : "N"
        this.pallets = this.quotation.isPallets ? "S" : "N"
        this.partialBilling = this.quotation.isPartialBilling ? "S" : "N"
        this.customerSalesOrder = this.quotation.customerSalesOrder
        this.shippingMessage = this.quotation.shippingMessage
        this.invoiceMessage = this.quotation.invoiceMessage
      }
    },

    mounted() {

      $("#select-issue-report").dropdown()
      $("#select-pallets").dropdown()

      const self = this
      $("#select-partial-billing").dropdown({
        onChange: function(value) {
          if (self.isResetting) return
          self.partialBilling = value
          if (value === "S" && self.quotation && self.quotation.paymentCondition) {
            if (QuotationService.isPartialBillingBlocked(self.quotation.paymentCondition)) {
              Message.warn("Condição de Pagamento não aceita Faturamento Parcial.")
            }
          }
          self.onChange()
        }
      })

      if (this.isUpdating && this.partialBilling) {
        this.isResetting = true
        $("#select-partial-billing").dropdown("set selected", this.partialBilling)
        this.isResetting = false
      }
    },

    methods: {

      setIssueReport(isIssueReport) {
        this.issueReport = isIssueReport ? "S" : "N"
        $("#select-issue-report").dropdown("set selected", this.issueReport)
      },

      resetPartialBilling() {
        this.isResetting = true
        this.partialBilling = ""
        $("#select-partial-billing").dropdown("clear")
        this.isResetting = false
      },

      onChange() {

        let data = {
          isIssueReport: undefined,
          isPallets: undefined,
          isPartialBilling: undefined,
          customerSalesOrder: cleanSpecialChars(this.customerSalesOrder),
          shippingMessage: cleanSpecialChars(this.shippingMessage),
          invoiceMessage: cleanSpecialChars(this.invoiceMessage),
        }

        if (this.issueReport)
          data.isIssueReport = (this.issueReport == "S")

        if (this.pallets)
          data.isPallets = (this.pallets == "S")

        if (this.partialBilling)
          data.isPartialBilling = (this.partialBilling == "S")

        this.$emit("onChange", data)
      },
    },
  }
</script>
